module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#list",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLUSTRATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("1 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Sullivan (1744–1808)")]), _vm._v(" The Republican governor of Massachusetts during the embargo controversy. By H. Wright Smith after Gilbert Stuart. (This item is reproduced by permission of the Huntington Library, San Marino, California.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("2 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Levi Lincolm (1749–1820)")]), _vm._v(" James Sullivan’s lieutenant governor and successor. By William S. Lincoln in the possession of Mrs. J. W. Wetherall. (This item is reproduced by permission of the Huntington Library, San Marino, California.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("3 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timothy Pickering (1745–1829)")]), _vm._v(" The controversial Federalist congressman from Massachusetts. By H. Wright Smith after Gilbert Stuart. (This item is reproduced by permission of the Huntington Library, San Marino, California.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("4 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Hillhouse (1754–1832)")]), _vm._v(" Timothy Pickering’s roommate in Washington for many years and Connecticut’s most prominent Federalist. Engraving by A. H. Ritchie. (Courtesy of Sterling Memorial Library, Yale University.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("5 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Josiah Quincy (1772–1864)")]), _vm._v(" Federalism’s most flamboyant spokesman in Congress. From an oil painting by Gilbert Stuart, 1824. (Photograph © 2004 Museum of Fine Arts, Boston.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("6 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harrison Gray Otis (1756–1848)")]), _vm._v(" A leading Boston Federalist. From an oil painting by Gilbert Stuart, 1809. (Courtesy of the Society for the Preservation of New England Antiquities.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("7 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christopher Gore (1758–1827)")]), _vm._v(" A Federalist governor of Massachusetts. From an oil on panel by John Trumbull, circa 1802–1804. (Courtesy of the Massachusetts Historical Society.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("8 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elbridge Gerry (1744–1814)")]), _vm._v(" A Republican governor of Massachusetts and vice president of the United States. Engraving copy by Longacre, after Vonderlyn. (Courtesy of the Massachusetts Historical Society.)")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("9 "), _c('span', {
    attrs: {
      "href": "#/OEBPS/photos#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caleb Strong (1745–1819)")]), _vm._v(" The Federalist governor of Massachusetts during the War of 1812. From an oil on canvas by James B. Marston, 1807. (Courtesy of the Massachusetts Historical Society.)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e594da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/list.vue
// module id = 69
// module chunks = 0